module.exports = __webpack_public_path__ + "img/technology3.483e8d6c.png";